import axios from 'axios'

export default class PaymentStatus
{
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...PaymentStatus.prototype.defaults, ...options }
        this.init()
    }

    init() {
        this.paymentStatusShowUrl = this.DOM.$el.dataset[this.options.attrPaymentStatusShowUrl];
        this.paymentStatusUrl = this.DOM.$el.dataset[this.options.attrPaymentStatusUrl];
        this.poll(this.paymentStatusUrl, this.paymentStatusShowUrl);
    }

    poll(statusUrl, showUrl){
        var status = setInterval(function(){
            axios.get(statusUrl, {
                responseType: 'json'
            })
            .then(function (data){
                if(data.data.status == 'PAID') {
                    window.location = showUrl;
                    clearInterval(status);
                }
            })
        }, 2000);
    }
}

PaymentStatus.prototype.defaults = {
    attrPaymentStatusUrl: 'paymentStatusUrl',
    attrPaymentStatusShowUrl: 'paymentStatusShowUrl',
}